import React, { Component } from "react";

class EncuestaTipo1 extends Component {
  render() {
    return (
      <fieldset className="panel">
        <legend>{this.props.quizz.descripcion}</legend>
        <div className="container">
          {this.props.quizz.verificaciones.map((verificacion) => {
            return (
              <div key={verificacion.id}>
                {verificacion.submodulo_descripcion ? (
                  <>
                    <hr />
                    <div className="panel">
                      {verificacion.submodulo_descripcion}
                    </div>
                  </>
                ) : null}
                <hr />
                <div className="row" id={verificacion.id}>
                  <div className="col-lg-5 d-flex">
                    <div className="align-self-center">
                      {verificacion.descripcion}
                    </div>
                  </div>

                  {this.props.respuestas.map((respuesta) => (
                    <div className="col-lg-1 d-flex" key={respuesta.id}>
                      <div className="form-check align-self-center">
                        <input
                          type="radio"
                          value={respuesta.id}
                          required
                          onChange={(e) =>
                            this.props.handleRadioEncuestaChange(e)
                          }
                          name={"verificacion-" + verificacion.id}
                          id={"verificacion-" + verificacion.id}
                          className="form-check-input"
                        />
                        <label className="form-check-label">
                          {respuesta.codigo}.
                        </label>
                      </div>
                    </div>
                  ))}

                  <div
                    className={
                      ["3", "11", "12"].includes(this.props.encuesta_id)
                        ? "col-lg-4 d-flex align-self-center"
                        : "col-lg-3 d-flex align-self-center"
                    }
                  >
                    <div className="input-group">
                      <textarea
                        name={"observacion-" + verificacion.id}
                        id={"observacion-" + verificacion.id}
                        onChange={(e) =>
                          this.props.handleTextAreaEncuestaChange(e)
                        }
                        className="form-control"
                        placeholder="Observaciones"
                      ></textarea>
                      {verificacion.ultima_observacion != null ? (
                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            data-toggle="tooltip"
                            type="button"
                            data-placement="top"
                            title={verificacion.ultima_observacion}
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </fieldset>
    );
  }
}

export default EncuestaTipo1;
